import { render, staticRenderFns } from "./homeSystem.vue?vue&type=template&id=65d861dd&scoped=true"
import script from "./homeSystem.vue?vue&type=script&lang=js"
export * from "./homeSystem.vue?vue&type=script&lang=js"
import style0 from "./homeSystem.vue?vue&type=style&index=0&id=65d861dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d861dd",
  null
  
)

export default component.exports